import { useMediaQuery, useTheme } from '@mui/material';

export const BANNER_AND_SLIDER_HEIGHT_DESKTOP = 550;
export const BANNER_AND_SLIDER_HEIGHT_MOBILE = 785;
export const BANNER_AND_SLIDER_HEIGHT_MOBILE_800 = 800;
export const BANNER_AND_SLIDER_HEIGHT_MOBILE_SM = 825;

export const useBannerAndSliderHeights = (): number => {
    const theme = useTheme();
    const isMobileMD = useMediaQuery(theme.breakpoints.down('md'));
    const isMobileSM = useMediaQuery(theme.breakpoints.down('sm'));

    if (isMobileSM) {
        return BANNER_AND_SLIDER_HEIGHT_MOBILE_SM;
    }
    if (isMobileMD) {
        return BANNER_AND_SLIDER_HEIGHT_MOBILE;
    }
    return BANNER_AND_SLIDER_HEIGHT_DESKTOP;
};